import React from 'react'
//import HOC from '../../hocs/navHOC'
import WhitePanel from '../../UI/white-panel/whitePanel'
import {
  fetchData,
  fetchMusicGenres,
  c,
  isPlayingInBackground,
  setCurrentPlaylist,
  setCurrentSong,
  setGoToCurrentPlayList
} from '../../action/musicAction'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import SearchBar from '../../UI/search-bar/searchBar'
import PlayList from './playlist/playList'
import MusicList from './music-list/musiclist'
import {
  setCurrentHomePage,
  setGoHome,
  setLoader
} from "../../layout2.0/action/homeAction";
import loader from '../../layout2.0/UI/loader';
import WarningConfirmationPopup from '../../layout2.0/UI/warningConfirmationPopup';
import { CMSPath } from '../../config/constant';
import { currentWidget } from '../../action/action';
import { musicWidgetTypes } from '../../config/layout2constant';

class Music extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      showConfirmatinPopup: false,
      showMusicList: false,
      selectedPlaylist: null
    }
  }


  handleGoPlayList = (selectedPlaylist) => {

    if(!selectedPlaylist){
      return;
    }

    this.setState({selectedPlaylist: selectedPlaylist, showMusicList: true});
  }

  componentDidMount() {

    const isMusicTabThere = this.props.footerTabList.findIndex(tabList => musicWidgetTypes.some(el => el === tabList.uniqueKey.toLowerCase()));

    if(isMusicTabThere != -1){
        this.props.setCurrentHomePage(this.props.footerTabList[isMusicTabThere]);
    } else {
      this.props.currentWidget({ widgetType: "Music" });
    }

    this.props.fetchMusicGenres()

    if (this.props.goToCurrentPlaylist) {
      this.props.setGoToCurrentPlayList(false);
      this.props.currentPlaylist && this.handleGoPlayList(this.props.currentPlaylist);
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.goToCurrentPlaylist != this.props.goToCurrentPlaylist && this.props.goToCurrentPlaylist){
      this.props.setGoToCurrentPlayList(false);
      this.props.currentPlaylist && this.handleGoPlayList(this.props.currentPlaylist);
    }
  }

  handleCloseMusicList = () => {
    this.setState({selectedPlaylist: null, showMusicList: false})
  }


  handleClearDataWhileGoingHome = () => {
    this.props.setCurrentSong(null);
    this.props.setCurrentPlaylist(null);
    this.props.setGoHome(true);
  }


  handleGoBack = () => {

    if(this.props.currentSong && this.props.currentSong.playSong){
      if(this.props.currentWidgetObj.widgetType){
        this.setState({showConfirmatinPopup: true});
      }
      return;
    }

    this.handleClearDataWhileGoingHome();
  }

  componentWillUnmount() {
    this.handleGoBack();
    this.props.setGoHome(true);
  }

  render() {

    return (
      <>

      {this.props.currentWidgetObj.widgetType && 
      <header className="inner-pages w-footer subpages">
        <a onClick={this.handleGoBack}
          className="button-back"></a>

        <div className="heading align-center">
          <div class="splash-brand">
            <img src={`${CMSPath}${this.props.logo}`} />
          </div>
        </div>
      </header>}
          <>
            <div id="listen" className="contentSection" style={{ marginTop: "4rem" }}>
              {
                this.state.showMusicList ?
                  <MusicList selectedPlaylist={this.state.selectedPlaylist} handleGoBack={this.handleCloseMusicList} /> : <PlayList handleGoNext={this.handleGoPlayList} handleGoBack={this.handleGoBack} />
              }

              {
                this.state.showConfirmatinPopup &&
                <WarningConfirmationPopup
                  message="Do you want to play music in background?"
                  onYesClick={() => {
                    this.props.setGoHome(true);
                  }}
                  onNoclick={() => {
                    this.handleClearDataWhileGoingHome();
                  }}
                />
              }

            </div>
          </>
      </>
    )
  }
}

Music.defaultProps = {
  musicList: [{}]
}

const mapStateToProps = state => {
  return {
    genres: state.store.music.musicGenres.genres,
    goToCurrentPlaylist: state.store.music.goToCurrentPlaylist,
    footerTabList: state.store.home.currentDuration && state.store.home.currentDuration.tabDetails && state.store.home.currentDuration.tabDetails.length > 0 ? state.store.home.currentDuration.tabDetails : [],
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    stringConst: state.store.home.stringConst,
    currentPlaylist: state.store.music.currentPlaylist,
    showLoader: state.store2.showLoader,
    currentSong: state.store.music.currentSong,
    logo: state.store.home.currentDuration.brandingInfo ?
      state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
  }
}

export default connect(
  mapStateToProps,
  {
    fetchData,
    setGoHome,
    setGoToCurrentPlayList,
    setCurrentHomePage,
    currentWidget,
    setCurrentSong,
    setCurrentPlaylist,
    isPlayingInBackground,
    fetchMusicGenres,
    setLoader
  }
)(Music);